import { useContext, useEffect, useState } from "react";
import GeneralContext from "../../../context/GeneralContext/GeneralContext";
import api from "../../../services/api";
import { displayMessage } from "../../../helpers/messages";
import SL_Button from "../../../components/buttons/Button";
import { SL_Input } from "../../../components/input/Input";
import { Form, Modal, Select } from "antd";

export function CreateStretchingExerciseModal({ onCloseModal, stretchingId }) {
	const [form] = Form.useForm();
	const { setShowLoading } = useContext(GeneralContext);
	const [catalogOptions, setCatalogOptions] = useState([]);

	useEffect(() => {
		loadCatalog();
	}, []);

	async function loadCatalog() {
		try {
			const response = await api.exercises.list();
			setCatalogOptions(
				response.data.map((e) => ({ value: e.id, label: e.name, data: e }))
			);
		} catch (error) {
			console.error("Erro ao carregar catálogo:", error);
		}
	}

	function onSelectFromCatalog(value, option) {
		const exercise = option.data;
		form.setFieldsValue({
			exercise_id:  exercise.id,
			name:         exercise.name,
			description:  exercise.description  ?? "",
			video_url:    exercise.video_url    ?? "",
			sets:         exercise.sets         ?? 3,
			reps:         exercise.reps         ?? "30s",
			rest_seconds: exercise.rest_seconds ?? 30,
		});
	}

	async function onFinishForm(values) {
		try {
			setShowLoading(true);
			await api.stretchingExercises.create({
				...values,
				stretching_id: stretchingId,
			});
			await onCloseModal(true);
		} catch (error) {
			console.error("Erro ao criar exercício:", error);
		} finally {
			setShowLoading(false);
		}
	}

	return (
		<Modal
			title={
				<div className="text-xl font-bold text-red-700 mr-3">
					{displayMessage("ADD_EXERCISE")}
				</div>
			}
			open={true}
			onCancel={() => onCloseModal(false)}
			centered={true}
			footer={
				<div className="flex flex-col ss:flex-row gap-2 justify-end">
					<SL_Button
						className="w-full ss:w-[150px] bg-gray-500 border-transparent"
						onClick={() => onCloseModal(false)}
					>
						{displayMessage("CLOSE")}
					</SL_Button>
					<SL_Button
						className="w-full ss:w-[150px] m-0 bg-red-600"
						onClick={() => form.submit()}
					>
						{displayMessage("END_REGISTER")}
					</SL_Button>
				</div>
			}
			maskClosable={false}
			width={600}
		>
			<Form
				onFinish={onFinishForm}
				layout="vertical"
				form={form}
				className={`flex gap-2 flex-col`}
			>
				<Form.Item name="exercise_id" hidden>
					<SL_Input type="number" />
				</Form.Item>

				<div className="mb-1">
					<span className="text-red-700 font-semibold text-sm">
						{displayMessage("SELECT_EXERCISE_FROM_CATALOG")}:
					</span>
					<Select
						showSearch
						className="w-full mt-1"
						placeholder={displayMessage("SEARCH_EXERCISE")}
						optionFilterProp="label"
						options={catalogOptions}
						onSelect={onSelectFromCatalog}
						allowClear
						onClear={() => form.resetFields()}
					/>
				</div>

				<Form.Item
					label={
						<span className="text-red-700 font-semibold">
							{displayMessage("EXERCISE_NAME")}:
						</span>
					}
					name="name"
					className={`w-full m-0`}
					required
					rules={[
						{ required: true, message: displayMessage("NAME_MANDATORY") },
					]}
					initialValue={""}
				>
					<SL_Input type="text" className="text-red-700" />
				</Form.Item>

				<Form.Item
					label={
						<span className="text-red-700 font-semibold">
							{displayMessage("DESCRIPTION")}:
						</span>
					}
					name="description"
					className={`w-full m-0`}
					initialValue={""}
				>
					<SL_Input textarea={true} rows={2} className="text-red-700" />
				</Form.Item>

				<Form.Item
					label={
						<span className="text-red-700 font-semibold">
							{displayMessage("VIDEO_URL")}:
						</span>
					}
					name="video_url"
					className={`w-full m-0`}
					initialValue={""}
				>
					<SL_Input type="url" className="text-red-700" placeholder="https://youtube.com/watch?v=..." />
				</Form.Item>

				<div className="gap-4 flex w-full flex-col smb:flex-row mt-2">
					<Form.Item
						label={
							<span className="text-red-700 font-semibold">
								{displayMessage("SETS")}:
							</span>
						}
						name="sets"
						className={`w-full m-0`}
						initialValue={3}
					>
						<SL_Input type="number" className="text-red-700" />
					</Form.Item>

					<Form.Item
						label={
							<span className="text-red-700 font-semibold">
								{displayMessage("REPS")}:
							</span>
						}
						name="reps"
						className={`w-full m-0`}
						initialValue={"30s"}
					>
						<SL_Input type="text" className="text-red-700" placeholder="Ex: 30s, 1min, 10-15" />
					</Form.Item>
				</div>

				<div className="gap-4 flex w-full flex-col smb:flex-row mt-2">
					<Form.Item
						label={
							<span className="text-red-700 font-semibold">
								{displayMessage("REST_SECONDS")}:
							</span>
						}
						name="rest_seconds"
						className={`w-full m-0`}
						initialValue={30}
					>
						<SL_Input type="number" className="text-red-700" />
					</Form.Item>

					<Form.Item
						label={
							<span className="text-red-700 font-semibold">
								{displayMessage("ORDER_INDEX")}:
							</span>
						}
						name="order_index"
						className={`w-full m-0`}
						initialValue={0}
					>
						<SL_Input type="number" className="text-red-700" />
					</Form.Item>
				</div>
			</Form>
		</Modal>
	);
}


